import constant from '../../store/constant'
var utils = require('../../utils')

export default {
  name: 'nsips-doctor-list',
  data: function () {
    return {
      shopId: null,
      doctorId: null,
      doctorName: null,
      nsDoctorCode: null,
      nsDoctorName: null,
      searchDoctorName: null,
      nsDoctorLoading: true,
      doctorLoading: true,
      firstLoading: true
    }
  },
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロールイベント削除
    this.$store.dispatch('NS_DOCTOR_AUTOCOMPLETE_CLEAR', 0)
    next()
  },
  created: function () {
    if (this.$store.getters.canManage) {
      this.shopId = this.$store.getters.currentShopId
    }
    this.search()
    this.getNsDoctors(true)
    utils.scrollBottomSearchEvent(this.getDoctors, true, 'button.next-page-search-btn')
  },
  computed: {
    shops () {
      return this.$store.getters.shops
    },
    doctors () {
      return this.$store.getters.doctors
    },
    nsDoctors () {
      return this.$store.getters.ns_doctors
    },
    currentPage () {
      return this.$store.getters.doctorsCurrentPage
    },
    nextPage () {
      return this.$store.getters.doctorsNextPage
    }
  },
  methods: {
    search: function () {
      self = this
      this.$store.dispatch('SHOP_SEARCH', {data: { all_get: true }, 'allShopName': this._self.$t('AllShopName'), callback: () => {
        self.getDoctors(false)
      }})
    },
    getDoctors: function (readMore) {
      var self = this
      var url = null

      if (readMore) {
        url = self.$store.getters.doctorsNextPageLink
      }

      self.doctorLoading = true
      self.$store.dispatch('DOCTOR_SEARCH', {
        url: url,
        data: {
          'shop_id': self.shopId,
          'doctor_name': self.searchDoctorName
        },
        callback: () => {
          self.doctorLoading = false
          self.getNsDoctors(false)
        }
      })
    },
    getNsDoctors: function (flg) {
      self = this
      if (self.firstLoading) {
        self.nsDoctorLoading = true
        this.$store.dispatch('NS_DOCTORS_SEARCH', { data: { shop_id: self.shopId }, callback: () => {
          if(self.$router.currentRoute.query.doctor_code != null && self.$router.currentRoute.query.doctor_name != null){
            self.nsDoctorName = self.$router.currentRoute.query.doctor_name
            if(flg){
              setTimeout(function () {
                for (var i in self.nsDoctors) {
                  if (
                    self.nsDoctors[i].attributes['doctor-code'] == self.$router.currentRoute.query.doctor_code && self.nsDoctors[i].attributes['clinical-department-code'] == self.$router.currentRoute.query.clinical_department_code && self.nsDoctors[i].attributes['medical-institution-reception-code'] == self.$router.currentRoute.query.medical_institution_reception_code) {
                    self.nsDoctorCode = self.nsDoctors[i]
                  }
                }
              }, 100)
            }
          }
          self.nsDoctorLoading = false
        }})
        self.firstLoading = false
      }
    },
    matching: function () {
      self = this
      self.firstLoading = true
      this.$store.dispatch('NS_DOCTOR_MATCHING', { data: { doctor_id: this.doctorId, doctor_code: this.nsDoctorCode.attributes['doctor-code'], medical_institution_reception_code: this.nsDoctorCode.attributes['medical-institution-reception-code'], clinical_department_code: this.nsDoctorCode.attributes['clinical-department-code'], shop_id: self.shopId }, callback: () => {
        self.getNsDoctors()
        self.search()
      }})
    },
    createDoctor: function () {
      if (this.nsDoctorCode !== null) {
        self = this
        this.$router.push({ path: '/doctors/edit', query: { type: 'select_facility', nsips: 'doctor', doctor_code: this.nsDoctorCode.attributes['doctor-code'], medical_institution_reception_code: this.nsDoctorCode.attributes['medical-institution-reception-code'], clinical_department_code: this.nsDoctorCode.attributes['clinical-department-code'], shop_id: self.shopId } })
      } else {
        return false
      }
    },
    setNsDoctorName: function (nsDoctorName) {
      this.nsDoctorName = nsDoctorName
    },
    setDoctorData: function (id, doctorName) {
      this.doctorId = id
      this.doctorName = doctorName
    },
    unsetDoctorData: function () {
      this.doctorId = null
      this.doctorName = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/nsips-doctor-list.js